/**
 * Builds the URL that sends the browser through Google with prompt=none so the API can
 * refresh the current user's name/avatar. Must be a top-level navigation (not fetch): the
 * API answers with a 302 to accounts.google.com and later redirects back to `returnTo`.
 */
export const buildSilentResyncUrl = (returnTo: string): string =>
  `/api/auth/google?silent=1&returnTo=${encodeURIComponent(returnTo)}`;
